export default function () {
  const el = document.getElementById('js-loading')
  el.classList.add('is-loaded')
}



// WEBPACK FOOTER //
// ./src/komachi-official/assets/scripts/modules/Loading.js